import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalEditableAccountDocument = gql`
  query SalesPortalEditableAccount(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    restaurant: businesses_by_pk(uuid: $restaurantUUID) {
      uuid
      name
      address {
        uuid
        address
        address2
      }
      restaurant_chats(
        limit: 1
        where: { supplier_uuid: { _eq: $supplierUUID } }
      ) {
        restaurant_account_id
        restaurant_notes
        chat_route_metadata {
          name
        }
      }
    }
  }
`;
export function useSalesPortalEditableAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalEditableAccountQuery,
    Types.SalesPortalEditableAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalEditableAccountQuery,
    Types.SalesPortalEditableAccountQueryVariables
  >(SalesPortalEditableAccountDocument, options);
}
export function useSalesPortalEditableAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalEditableAccountQuery,
    Types.SalesPortalEditableAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalEditableAccountQuery,
    Types.SalesPortalEditableAccountQueryVariables
  >(SalesPortalEditableAccountDocument, options);
}
export type SalesPortalEditableAccountQueryHookResult = ReturnType<
  typeof useSalesPortalEditableAccountQuery
>;
export type SalesPortalEditableAccountLazyQueryHookResult = ReturnType<
  typeof useSalesPortalEditableAccountLazyQuery
>;
export type SalesPortalEditableAccountQueryResult = Apollo.QueryResult<
  Types.SalesPortalEditableAccountQuery,
  Types.SalesPortalEditableAccountQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalEditableAccountQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalEditableAccountQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalEditableAccountQuery,
    Types.SalesPortalEditableAccountQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalEditableAccountQuery,
    Types.SalesPortalEditableAccountQueryVariables
  >(SalesPortalEditableAccountDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalEditableAccountLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalEditableAccountLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalEditableAccountQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalEditableAccountQuery,
    Types.SalesPortalEditableAccountQueryVariables
  >(SalesPortalEditableAccountDocument, lazyOptions);
}
